import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import { styled } from '@mui/material/styles';
import theme from './theme';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PrivateRoute from './components/layout/PrivateRoute';
import ErrorBoundary from './components/common/ErrorBoundary';

// Scadenze pages
import ScadenzeListPage from './pages/scadenze/ScadenzeListPage';
import ScadenzaFormPage from './pages/scadenze/ScadenzaFormPage';
import ScadenzaDetailPage from './pages/scadenze/ScadenzaDetailPage';

// Clienti pages
import ClientiListPage from './pages/clienti/ClientiListPage';
import ClienteDetailPage from './pages/clienti/ClienteDetailPage';
import ClienteFormPage from './pages/clienti/ClienteFormPage';

// Users pages
import UsersListPage from './pages/users/UsersListPage';
import UserFormPage from './pages/users/UserFormPage';

// Tipologie pages
import TipologieListPage from './pages/tipologie/TipologieListPage';
import TipologiaFormPage from './pages/tipologie/TipologiaFormPage';

// Queue pages
import QueueDashboardPage from './pages/queue/QueueDashboardPage';

// Email Templates pages
import EmailTemplatesListPage from './pages/email-templates/EmailTemplatesListPage';
import EmailTemplateFormPage from './pages/email-templates/EmailTemplateFormPage';

// Styled Material Design Content per i toast
const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#43a047',
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#d32f2f',
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: '#ff9800',
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: '#1976d2',
  },
}));

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={5000}
          preventDuplicate
          Components={{
            success: StyledMaterialDesignContent,
            error: StyledMaterialDesignContent,
            warning: StyledMaterialDesignContent,
            info: StyledMaterialDesignContent,
          }}
        >
          <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            {/* Dashboard */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              }
            />

            {/* Scadenze Routes */}
            <Route
              path="/scadenze"
              element={
                <PrivateRoute>
                  <ScadenzeListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/scadenze/new"
              element={
                <PrivateRoute>
                  <ScadenzaFormPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/scadenze/:id"
              element={
                <PrivateRoute>
                  <ScadenzaDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/scadenze/:id/edit"
              element={
                <PrivateRoute>
                  <ScadenzaFormPage />
                </PrivateRoute>
              }
            />

            {/* Clienti Routes */}
            <Route
              path="/clienti"
              element={
                <PrivateRoute>
                  <ClientiListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/clienti/new"
              element={
                <PrivateRoute>
                  <ClienteFormPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/clienti/:id"
              element={
                <PrivateRoute>
                  <ClienteDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/clienti/:id/edit"
              element={
                <PrivateRoute>
                  <ClienteFormPage />
                </PrivateRoute>
              }
            />

            {/* Users Routes */}
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <UsersListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/users/new"
              element={
                <PrivateRoute>
                  <UserFormPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/users/:id/edit"
              element={
                <PrivateRoute>
                  <UserFormPage />
                </PrivateRoute>
              }
            />

            {/* Tipologie Routes */}
            <Route
              path="/tipologie"
              element={
                <PrivateRoute>
                  <TipologieListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/tipologie/new"
              element={
                <PrivateRoute>
                  <TipologiaFormPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/tipologie/:id/edit"
              element={
                <PrivateRoute>
                  <TipologiaFormPage />
                </PrivateRoute>
              }
            />

            {/* Queue Routes */}
            <Route
              path="/queue"
              element={
                <PrivateRoute>
                  <QueueDashboardPage />
                </PrivateRoute>
              }
            />

            {/* Email Templates Routes */}
            <Route
              path="/email-templates"
              element={
                <PrivateRoute>
                  <EmailTemplatesListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/email-templates/new"
              element={
                <PrivateRoute>
                  <EmailTemplateFormPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/email-templates/:id/edit"
              element={
                <PrivateRoute>
                  <EmailTemplateFormPage />
                </PrivateRoute>
              }
            />

            {/* Redirects */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
        </SnackbarProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
